module.exports = __webpack_public_path__ + "img/in-progress.b0d7c073.svg";